module.exports = __webpack_public_path__ + "img/f896c4224cdbade25714f9037a2c1fe9.png";